import React, { useContext, useState, useEffect } from "react";
import {
  Col,
  Row,
  Card,
  Form,
  Button,
  Spinner,
  InputGroup,
  Dropdown,
} from "@themesberg/react-bootstrap";
import { Context } from "../Input";
import { getToday, getNext7Days } from "../Input";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faPlus,
  faTimes,
  faCalendarAlt,
} from "@fortawesome/free-solid-svg-icons";
import { getAllChannel } from "../../../../controller/api/__classic__/channel";
import { useCookies } from "react-cookie";
import { includesSearchText } from "../../../../helper/text";

const _FilterForm = ({
  region,
  showRegionSelect,
  selectedRegion,
  onRegionChange,
  onAddTicket,
}) => {
  const { dispatch, state } = useContext(Context);
  const [cookies] = useCookies(["lottmekong"]);

  const [searchNumbers, setSearchNumbers] = useState("");
  const [searchTicketCode, setSearchTicketCode] = useState("");
  const [ticketType, setTicketType] = useState("all");
  const [selectedChannel, setSelectedChannel] = useState("");
  const [channelSearch, setChannelSearch] = useState("");
  const [channels, setChannels] = useState([]);
  const [fromDate, setFromDate] = useState(state.filter.fromDate || "");
  const [toDate, setToDate] = useState(state.filter.toDate || "");

  useEffect(() => {
    const fetchChannels = async () => {
      const response = await getAllChannel(cookies.lottmekong, region);
      if (response && response.data) {
        setChannels(response.data);
      }
    };
    fetchChannels();
    setSelectedChannel("");
    setChannelSearch("");
  }, [region, cookies.lottmekong]);

  const filteredChannels = channelSearch
    ? channels.filter((channel) =>
        includesSearchText(channel.name, channelSearch),
      )
    : channels;

  const handleSearch = () => {
    dispatch({
      type: "SUBMIT_FILTER",
      payload: {
        channel: selectedChannel,
        numbers: searchNumbers.replace(/\s/g, ""),
        ticketCode: searchTicketCode.replace(/\s/g, ""),
        ticketType: ticketType,
        fromDate: fromDate,
        toDate: toDate,
      },
    });
  };

  const handleClear = () => {
    const defaultFromDate = getToday();
    const defaultToDate = getNext7Days();
    setSearchNumbers("");
    setSearchTicketCode("");
    setTicketType("all");
    setSelectedChannel("");
    setChannelSearch("");
    setFromDate(defaultFromDate);
    setToDate(defaultToDate);
    dispatch({
      type: "SUBMIT_FILTER",
      payload: {
        channel: "",
        numbers: "",
        ticketCode: "",
        ticketType: "all",
        fromDate: defaultFromDate,
        toDate: defaultToDate,
      },
    });
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const getTitle = () => {
    if (showRegionSelect) {
      return "Vé Chờ Duyệt";
    }
    return `Vé ${region === "MN" ? "Miền Nam" : "Miền Trung"} Chờ Duyệt`;
  };

  return (
    <div className="mb-4">
      {/* Header Section */}
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-3 gap-3">
        <div>
          <h4 className="fw-bold mb-1 text-primary">{getTitle()}</h4>
          <p className="text-muted small mb-0">
            Quản lý và duyệt vé mới nhập vào hệ thống
          </p>
        </div>
        <Button
          variant="primary"
          onClick={onAddTicket}
          className="px-4 py-2 fw-bold shadow-sm d-flex align-items-center"
          style={{ height: "45px", borderRadius: "10px" }}
        >
          <FontAwesomeIcon icon={faPlus} className="me-2" />
          Nhập vé mới
        </Button>
      </div>

      {/* Filters Section */}
      <Card border="0" className="shadow-sm rounded-3">
        <Card.Body className="p-4">
          <Row className="g-3">
            {/* Region Select (Conditional) */}
            {showRegionSelect && (
              <Col xs={12} md={6} lg={3}>
                <Form.Label className="small fw-bold text-muted mb-1">
                  Khu vực
                </Form.Label>
                <Form.Select
                  value={selectedRegion}
                  onChange={(e) => onRegionChange(e.target.value)}
                  className="form-control-lg fs-6 bg-white"
                >
                  <option value="MN">Miền Nam</option>
                  <option value="MT">Miền Trung</option>
                  <option value="MB">Miền Bắc</option>
                </Form.Select>
              </Col>
            )}

            {/* Channel Select with Search */}
            <Col xs={12} md={6} lg={3}>
              <Form.Label className="small fw-bold text-muted mb-1">
                Đài (Tỉnh)
              </Form.Label>
              <Dropdown className="w-100">
                <Dropdown.Toggle
                  variant="white"
                  className="w-100 text-start d-flex align-items-center justify-content-between form-control-lg fs-6 bg-white border"
                  id="dropdown-channel-select"
                >
                  <span className="text-truncate">
                    {selectedChannel
                      ? channels.find(
                          (ch) => String(ch.id) === String(selectedChannel),
                        )?.name || "Tất cả đài"
                      : "Tất cả đài"}
                  </span>
                </Dropdown.Toggle>

                <Dropdown.Menu
                  className="w-100 p-2 shadow-sm"
                  style={{ maxHeight: "300px", overflowY: "auto" }}
                >
                  <div className="px-1 mb-2 sticky-top bg-white">
                    <InputGroup>
                      <InputGroup.Text className="bg-white border-end-0">
                        <FontAwesomeIcon
                          icon={faSearch}
                          className="text-muted"
                        />
                      </InputGroup.Text>
                      <Form.Control
                        autoFocus
                        placeholder="Tìm đài..."
                        value={channelSearch}
                        onChange={(e) => setChannelSearch(e.target.value)}
                        className="bg-white border-start-0 ps-0"
                        onClick={(e) => e.stopPropagation()}
                      />
                    </InputGroup>
                  </div>

                  <Dropdown.Item
                    active={selectedChannel === ""}
                    onClick={() => {
                      setSelectedChannel("");
                      setChannelSearch("");
                    }}
                    className="rounded-2"
                  >
                    Tất cả đài
                  </Dropdown.Item>

                  {filteredChannels.length > 0 ? (
                    filteredChannels.map((channel) => (
                      <Dropdown.Item
                        key={channel.id}
                        active={String(selectedChannel) === String(channel.id)}
                        onClick={() => {
                          setSelectedChannel(channel.id);
                          setChannelSearch("");
                        }}
                        className="rounded-2"
                      >
                        {channel.name}
                      </Dropdown.Item>
                    ))
                  ) : (
                    <div className="text-center text-muted small py-2">
                      Không tìm thấy đài
                    </div>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </Col>

            {/* Ticket Type Select */}
            <Col xs={12} md={6} lg={3}>
              <Form.Label className="small fw-bold text-muted mb-1">
                Loại vé
              </Form.Label>
              <Form.Select
                value={ticketType}
                onChange={(e) => setTicketType(e.target.value)}
                className="form-control-lg fs-6 bg-white"
              >
                <option value="all">Tất cả loại vé</option>
                <option value="single">Vé đơn</option>
                <option value="pair">Vé cặp nguyên</option>
              </Form.Select>
            </Col>

            {/* Search by Numbers */}
            <Col xs={12} md={6} lg={3}>
              <Form.Label className="small fw-bold text-muted mb-1">
                Tìm dãy số
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Nhập dãy số vé..."
                value={searchNumbers}
                onChange={(e) => setSearchNumbers(e.target.value)}
                onKeyPress={handleKeyPress}
                className="form-control-lg fs-6 bg-white"
              />
            </Col>

            {/* Search by Ticket Code */}
            <Col xs={12} md={6} lg={3}>
              <Form.Label className="small fw-bold text-muted mb-1">
                Tìm mã vé
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Nhập mã vé..."
                value={searchTicketCode}
                onChange={(e) => setSearchTicketCode(e.target.value)}
                onKeyPress={handleKeyPress}
                className="form-control-lg fs-6 bg-white"
              />
            </Col>

            {/* Date Range Filters */}
            <Col xs={12} md={6} lg={3}>
              <Form.Label className="small fw-bold text-muted mb-1">
                Từ ngày
              </Form.Label>
              <InputGroup
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  const input =
                    e.currentTarget.querySelector('input[type="date"]');
                  if (input && input.showPicker) {
                    input.showPicker();
                  } else if (input) {
                    input.focus();
                  }
                }}
              >
                <InputGroup.Text
                  className="bg-white border-end-0"
                  style={{ cursor: "pointer" }}
                >
                  <FontAwesomeIcon
                    icon={faCalendarAlt}
                    className="text-muted"
                  />
                </InputGroup.Text>
                <Form.Control
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  onKeyPress={handleKeyPress}
                  className="form-control-lg fs-6 bg-white border-start-0 ps-0"
                  style={{ cursor: "pointer" }}
                />
              </InputGroup>
            </Col>

            <Col xs={12} md={6} lg={3}>
              <Form.Label className="small fw-bold text-muted mb-1">
                Đến ngày
              </Form.Label>
              <InputGroup
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  const input =
                    e.currentTarget.querySelector('input[type="date"]');
                  if (input && input.showPicker) {
                    input.showPicker();
                  } else if (input) {
                    input.focus();
                  }
                }}
              >
                <InputGroup.Text
                  className="bg-white border-end-0"
                  style={{ cursor: "pointer" }}
                >
                  <FontAwesomeIcon
                    icon={faCalendarAlt}
                    className="text-muted"
                  />
                </InputGroup.Text>
                <Form.Control
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  onKeyPress={handleKeyPress}
                  className="form-control-lg fs-6 bg-white border-start-0 ps-0"
                  style={{ cursor: "pointer" }}
                />
              </InputGroup>
            </Col>

            {/* Action Buttons */}
            <Col
              xs={12}
              lg={12}
              className="d-flex justify-content-end gap-2 mt-4"
            >
              <Button
                variant="light"
                onClick={handleClear}
                className="px-4 py-2 fw-semibold text-muted"
              >
                <FontAwesomeIcon icon={faTimes} className="me-2" />
                Xóa lọc
              </Button>
              <Button
                variant="primary"
                onClick={handleSearch}
                className="px-5 py-2 fw-bold shadow-sm"
                disabled={state.isLoading}
                style={{ borderRadius: "8px" }}
              >
                {state.isLoading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Đang tìm...
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faSearch} className="me-2" />
                    Tìm kiếm
                  </>
                )}
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
};

export default React.memo(_FilterForm);
